import React from "react";
import { ProposalStore } from "../../../stores/proposalStore";
import { inject, observer } from "mobx-react";
import Header from "../../sharedComponents/header/header";
import TextInput from "../../sharedComponents/textInput/textInput";
import Regon from "../../sharedComponents/regon/regon";
import Nip from "../../sharedComponents/nip/nip";
import AutocompleteInput from "../../sharedComponents/autocompleteInput/autocompleteInput";
import ToggleButtonGroupCustom from "../../sharedComponents/toggleButtonGroup/toggleButtonGroup";
import { yesNo } from "../../../helpers/yesNo";
import { ErrorMessages } from "../../../helpers/errorMessage";
import Validator from "../../../helpers/validator";
import { CapitalizationType } from "../../../helpers/formatter";
import Address from "../../sharedComponents/address/address";
import { runInAction } from "mobx";
import { DictionariesStore } from "../../../stores/dictionariesStore";

interface CessionBankProps {
    dictionariesStore?: DictionariesStore;
    proposalStore?: ProposalStore;
    capitalize?: CapitalizationType;
}

@inject("dictionariesStore", "proposalStore")
@observer
export default class CessionBank extends React.Component<CessionBankProps> {

    constructor(props: any) {
        super(props);

        const proposalStore = this.props.proposalStore!;
        if (proposalStore.cession.cessionSelected && this.props.dictionariesStore!.banks.length === 0) {
            this.addValidatorsToBankName();
        }
    }

    public render() {
        const cession = this.props.proposalStore!.cession;
        const cessionSelected = cession.cessionSelected;
        return (
            <div className="section cession-bank">
                <Header type="medium" mainHeader="Cesja praw polisy" />
                {this.renderCessionQuestion()}
                {cessionSelected && (
                    <>
                        {this.bankName()}
                        {this.bankNameContinuation()}
                        <Address address={cession.address} displayLabel={true} />
                        <Nip value={cession.nip} required={true} />
                        <Regon value={cession.regon} />
                    </>
                )}
            </div>
        );
    }

    private renderCessionQuestion() {
        const proposalStore = this.props.proposalStore!;
        return (
            <ToggleButtonGroupCustom
                question={"Chcesz dodać cesję praw polisy?"}
                value={proposalStore.cession.cessionSelected ? yesNo.yes : yesNo.no}
                options={[{
                    value: yesNo.yes,
                    label: "TAK"
                }, {
                    value: yesNo.no,
                    label: "NIE"
                }]}
                onChange={(newValue) => {
                    const newValueToBoolean = newValue === yesNo.yes;
                    if (newValueToBoolean !== proposalStore.cession.cessionSelected) {
                        runInAction(() => {
                            // TODO: create setter and remove 'runInAction'
                            proposalStore.cession.cessionSelected = newValueToBoolean;
                        });
                    }
                }}
            />
        );
    }

    private bankName() {
        const bankName = this.props.proposalStore!.cession.bankName;
        return (
            <div className={`field-container bank-name`}>
                <div className="label">Nazwa banku</div>
                <AutocompleteInput
                    values={this.filterBanks(this.props.dictionariesStore!.banks, bankName.value)}
                    onInputChange={(event, value) => {
                        this.onInputChange(value);
                    }}
                    clearValidation={() => bankName.clearValidation()}
                    value={bankName.value ?? ""}
                    onBlur={() => {
                        bankName.setValue(bankName.value.trim());
                        bankName.validate();
                    }}
                    errorMessage={bankName.errorMessage}
                    topLabel={"Nazwa banku"}
                />
            </div>
        );
    }

    private bankNameContinuation() {
        return (
            <div className="field-container bank-name-continuation">
                <div className="label">Nazwa banku cd.</div>
                <TextInput
                    validatedValue={this.props.proposalStore!.cession.bankNameContinuation}
                    topLabel="Nazwa banku cd."
                    capitalize={this.props.capitalize}
                />
            </div>
        );
    }

    private filterBanks(banks: string[], value: string) {
        let count = 0;
        const maxItems = 5;
        const regExp = new RegExp(value.split("").join("\\w*").replace(/\W/, ""), "i");

        return (!!value && !!banks && banks.length > 0)
            ? banks.filter((bank) => {
                if (count < maxItems && bank.match(regExp)) {
                    count++;
                    return bank;
                }
                return false;
            }, { count: 0 })
            : [];
    }

    private filterMatchingBanks(value: string) {
        let count = 0;
        const maxItems = 5;
        const proposalStore = this.props.proposalStore!;
        const regExp = new RegExp(value.split("").join("\\w*").replace(/\W/, ""), "i");

        const filteredBanks = (value !== "")
            ? proposalStore.cessionBanks.filter((bank) => {
                if (count < maxItems && bank.match(regExp)) {
                    count++;
                    return bank;
                }
                return false;
            }, { count: 0 })
            : [];

        this.setState({ banks: filteredBanks });
    }

    private onInputChange(value: string) {
        this.props.proposalStore!.cession.bankName.setValue(value);
        this.filterMatchingBanks(value);
    }

    private addValidatorsToBankName() {
        const proposalStore = this.props.proposalStore!;

        proposalStore.cession.bankName.addValidators({
            name: "bankNameIsValid",
            fn: Validator.isValidBankName(proposalStore.cessionBanks),
            errorMessage: ErrorMessages.cession.bank
        });
    }
}
